import React from 'react'
import { Button, Modal } from 'antd'
import styled from '@emotion/styled'
import { CommonButton } from 'components/Common'
import {
  ARCHIVE_DIALOG_CONFIRM,
  archiveDialogBody,
  archiveDialogTitle
} from './wording'

interface ArchiveMultiplierModalProps {
  isOpen: boolean
  name: string
  onConfirm: () => void
  onCancel: () => void
  saving?: boolean
  /** The edit form has unsaved edits that archiving discards */
  withUnsavedWarning?: boolean
}

export const ArchiveMultiplierModal = ({
  isOpen,
  name,
  onConfirm,
  onCancel,
  saving = false,
  withUnsavedWarning = false
}: ArchiveMultiplierModalProps) => (
  <Modal
    open={isOpen}
    width={480}
    centered
    closable={false}
    footer={null}
    bodyStyle={{ padding: 24 }}
    onCancel={() => {
      // Mask click and Esc must not close the dialog mid-archive
      if (!saving) onCancel()
    }}
  >
    <Title>{archiveDialogTitle(name)}</Title>
    <Body>{archiveDialogBody(withUnsavedWarning)}</Body>
    <Actions>
      <Button type='primary' ghost onClick={onCancel} disabled={saving}>
        Cancel
      </Button>
      <CommonButton type='danger' onClick={onConfirm} loading={saving}>
        {ARCHIVE_DIALOG_CONFIRM}
      </CommonButton>
    </Actions>
  </Modal>
)

const Title = styled.h2`
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: 600;
  color: #4a4a68;
`

const Body = styled.p`
  margin-bottom: 0;
  font-size: 14px;
  line-height: 1.5;
  color: #4a4a68;
`

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
`
